import { render } from "./navmenu.vue?vue&type=template&id=37a2040c&scoped=true"
import script from "./navmenu.vue?vue&type=script&lang=js"
export * from "./navmenu.vue?vue&type=script&lang=js"

import "./navmenu.vue?vue&type=style&index=0&id=37a2040c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a2040c"]])

export default __exports__